import React, { useEffect, useState } from 'react'
import { getBatchEmployeeApi, updateBatchEmployeeApi } from '../../../../Api/BatchEmployee';
import toast from 'react-hot-toast';

interface Props {
    url: string;
    editbatchemployeeId?: string | null;
    onClose: () => void;
}

const BatchEmployeeForm = ({ url, editbatchemployeeId, onClose }: Props) => {
    const [batchId, setBatchId] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [hourlyRate, setHourlyRate] = useState<number | undefined>(undefined);
    const [startTime, setStartTime] = useState('');
    const [endtime, setEndtime] = useState('');
    const [StartDate, setStartDate] = useState<string | null>(null);
    const [EndDate, setEndDate] = useState<string | null>(null);

    useEffect(() => {
        handleApiClick();
    }, [editbatchemployeeId])

    const handleApiClick = async () => {
        try {
            const batchData: any = await getBatchEmployeeApi(url);
            if (!batchData || !Array.isArray(batchData)) {
                console.error("Invalid batch data format");
                return;
            }
            const batchEmployeeToEdit = batchData.find((employee: any) => employee.id === editbatchemployeeId);
            if (batchEmployeeToEdit) {
                setBatchId(batchEmployeeToEdit.batchId);
                setEmployeeId(batchEmployeeToEdit.employeeId);
                setHourlyRate(batchEmployeeToEdit.hourlyRate);
                setStartTime(batchEmployeeToEdit.startTime);
                setEndtime(batchEmployeeToEdit.endtime);
                setStartDate(batchEmployeeToEdit.startDate);
                setEndDate(batchEmployeeToEdit.endDate);
            }


        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await updateBatchEmployeeApi(url, {
              id: editbatchemployeeId,
              batchId,
              employeeId,
              hourlyRate,
              startTime,
              endTime: endtime,
              startDate: StartDate,
              endDate: EndDate
            });
            toast.success("Batch Employee updated successfully");
            onClose();
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    };

    return (
        <div>
            <h1 className="text-3xl font-bold text-blue-600 mb-5">Edit Batch Employee</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
                <h2 className="text-xl font-semibold">Edit Employee</h2>


                <div className="mt-10">
                    <label className="block text-sm font-medium">Hourly Rate<span className="text-red-500">*</span></label>
                    <input
                        type="number"
                        value={hourlyRate}
                        onChange={(e) => setHourlyRate(Number(e.target.value))}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder='Hourly Rate'
                        required
                    />
                </div>


                <div className="flex justify-between mt-10">
                    <div className="w-1/2 pr-2">
                        <label htmlFor="customStartTime" className="block text-sm font-medium text-black dark:text-gray-200 mb-2">
                            Start Time <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="time"
                            id="customStartTime"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required
                        />
                    </div>
                    <div className="w-1/2 pl-2">
                        <label htmlFor="customEndTime" className="block text-sm font-medium text-black dark:text-gray-200 mb-2">
                            End Time <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="time"
                            id="customEndTime"
                            value={endtime}
                            onChange={(e) => setEndtime(e.target.value)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            required
                        />
                    </div>
                </div>

                <div className='flex flex-row justify-between mt-10 gap-4 '>
                    {/* Start Date */}
                    <div className="flex flex-col space-y-2 w-full  ">
                        <label className="text-gray-900 dark:text-gray-200 font-semibold">Start Date<span className="text-red-500">*</span></label>
                        <input
                            required
                            name="StartDate"
                            type="date"
                            value={StartDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Start Date"
                        />
                    </div>

                    {/* Leaving Date */}
                    <div className="flex flex-col space-y-2 w-full ">

                        <label className="text-gray-900 dark:text-gray-200 font-semibold">End Date</label>
                        <input
                            name="leavingDate"
                            type="date"
                            value={EndDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="End Date"
                        />
                    </div>
                </div>




















                <div className="flex justify-start space-x-4">
                    <button
                        type="submit"
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        Update
                    </button>
                    <button
                        type="button"
                        onClick={() => onClose()}
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    )
}

export default BatchEmployeeForm